export function currency(value: number, locale = "en", label?: string | null) {
  let price = value;
  if (!value) {
    price = 0;
  }

  const isNegative = price < 0;
  const absoluteAmount = Math.abs(price) / 100;
  const cost = absoluteAmount.toFixed(2);

  const noLabel = label === null;
  const finalLabel = noLabel ? "" : (label || "CA");

  if (locale === "fr") {
    if (noLabel) {
      return isNegative ? `- ${cost} $` : `${cost} $`;
    }
    return isNegative ? `- ${cost} $ ${finalLabel}` : `${cost} $ ${finalLabel}`;
  }

  if (noLabel) {
    return isNegative ? `- $${cost}` : `$${cost}`;
  }

  return isNegative ? `- ${finalLabel} $${cost}` : `${finalLabel} $${cost}`;
}
